// import { createHigherOrderComponent } from '@wordpress/compose';
// import { addFilter } from '@wordpress/hooks';
// import { assign } from 'lodash';

// const withClientIdClassName = createHigherOrderComponent( ( BlockListBlock ) => {
// 	return ( props ) => {
// 		return <BlockListBlock { ...props } className={ 'block-apple-' + props.clientId } />;
// 	};
// }, 'withClientIdClassName' );

// addFilter( 'editor.BlockListBlock', 'my-plugin/with-client-id-class-name', withClientIdClassName );

// addFilter(
// 	'blocks.registerBlockType',
// 	'my-theme/namespace',
// 	function( settings, name ) {
// 	    if ( name === 'core/image' ) {
// 		    console.log(settings);
// 			return assign( {}, settings, {
// 		    supports: assign( {}, settings.supports, {
// 					// disable the align-UI completely ...
// 					align: false,
// 					// ... or only allow specific alignments
// 					// align: ['center,'full'],
// 		    } ),
// 			} );
// 	    }
// 	    return settings;
// 	}
// );

// addFilter(
// 	'editor.BlockEdit',
// 	'uagb/advanced-control-block',
// 	()=>{
// 		return 'test';
// 	}
// );
